import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '剧情攻略', href: '/category?tab=剧情攻略' },
  { label: '角色解析', href: '/category?tab=角色解析' },
  { label: '主题评测', href: '/category?tab=主题评测' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navScrolled = !isHome || scrolled;

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    if (href.includes('?')) {
      const [path, query] = href.split('?');
      return location.pathname === path && location.search === `?${query}`;
    }
    return location.pathname === href;
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        navScrolled ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500">
            <i className="ri-heart-pulse-line text-background-50 text-sm"></i>
          </div>
          <span
            className={`font-heading font-bold text-lg transition-colors ${
              navScrolled ? 'text-foreground-900' : 'text-background-50'
            }`}
          >
            悠之空
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" aria-label="主导航">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-primary-500 ${
                isActive(link.href)
                  ? navScrolled ? 'text-primary-600' : 'text-primary-200'
                  : navScrolled ? 'text-foreground-700' : 'text-background-50/90'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA */}
        <Link
          to="/category?tab=剧情攻略"
          className="hidden md:flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-book-open-line text-sm"></i>
          开始探索
        </Link>

        {/* Mobile Menu Button */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center rounded-lg transition-colors ${
            navScrolled ? 'text-foreground-700' : 'text-background-50'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="菜单"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-2">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setMenuOpen(false)}
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                isActive(link.href)
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/category?tab=剧情攻略"
            onClick={() => setMenuOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 bg-primary-500 text-background-50 text-sm font-medium px-4 py-2 rounded-full whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            开始探索
          </Link>
        </div>
      )}
    </header>
  );
}